import React from 'react';
import clsx from 'clsx';
import { FormControlLabel, Radio, RadioGroup, withStyles } from '@material-ui/core';

const styles = theme => ({
    radioContainer: {
        display: 'inline',
        marginLeft: '3px'
    },
    checkBox: {
        padding: '5px',
        color:"#6EA0D7",
        '&>span>input': {
            zIndex:0
        }
    },
})

const RadioButton = (props) => {
    let { classes, radioGroupClass, formControlClass, name, valueRadioGroup, onChange, extraOnChange,radioClassA, radioClassB, radioColorA = '#6EA0D7', radioColorB = '#6EA0D7', labelA, labelB, valueA, valueB, labelPlacementA, labelPlacementB } = props; 

    return (
        <RadioGroup className={clsx(classes.radioContainer, radioGroupClass)} name={name} value={valueRadioGroup} onChange={event => onChange(event, extraOnChange)}>
            <FormControlLabel
                className={formControlClass}
                control={<Radio className={clsx(classes.checkBox, radioClassA)} color={radioColorA}/>}
                label={labelA}
                value={valueA}
                labelPlacement={labelPlacementA}
            />
            <FormControlLabel
                className={formControlClass}
                control={<Radio className={clsx(classes.checkBox, radioClassB)} color={radioColorB}/>}
                label={labelB}
                value={valueB}
                labelPlacement={labelPlacementB}
            />
        </RadioGroup>
    )
};

export default withStyles(styles)(RadioButton);